import { findKey, get, includes } from 'lodash';
import { createSelector } from 'reselect';

import { cropIds, defaultNominalWeight } from 'constants/crops';

import type { Store } from 'store/types/types';

export const getCropList = (state) => get(state, 'crops');
export const getCropById = (state, cropId) => get(state, `crops.${cropId}.code`);
export const getCropUuidByLegacyId = (state, cropId) => get(state, `crops.${cropId}.uuid`);
export const getCropDfpUuidByLegacyId = createSelector([
  (state) => state.crops,
  (state, cropLegacyId) => cropLegacyId
],
(crops, cropLegacyId) => crops[cropLegacyId]?.['dfp-uuid']
);
export const getCropIdByCrop = (state, cropCode) => findKey(get(state, `crops`), (crop) => crop.code === cropCode);
export const getCropIdByCropName = (state, cropName) => findKey(get(state, `crops`), (crop) => crop.name === cropName);
export const getCropNameById = (state, cropId) => get(state, `crops.${cropId}.name`);
export const getSupportedCropIdsForAdvancedScripting = () => [ cropIds.CORN ];
export const cropCanAdvancedScript = (state, cropId) => {
  return includes( getSupportedCropIdsForAdvancedScripting(), cropId);
};
export const currentCropCanAdvancedScript = (state) => {
  return cropCanAdvancedScript(state, get(state, 'current.cropId'));
};
export const getDefaultCropId = () => cropIds.CORN;
export const getSupportedCrops = createSelector(
  [(state: Store) => state.crops],
  (crops) => {
    const result = [];

    const corn = crops[cropIds.CORN];
    if (corn) result.push(corn);

    const soybean = crops[cropIds.SOYBEAN];
    if (soybean) result.push(soybean);

    return result;
  }
);
export const getCropNominalWeights = (state) => {
  const cropList = getCropList(state);
  return Object.keys(getCropList(state)).reduce((weights, cropId) => {
    if (!isNaN(Number(cropId))) {
      weights[cropId] = get(cropList, `[${cropId}]['nominal-weight'].q`, defaultNominalWeight);
    }
    return weights;
  }, {});
};

export const getNominalWeightByCropId = (state: Store, cropId: number | string) =>
  state?.crops?.[cropId]?.['nominal-weight']?.q || defaultNominalWeight;
export const getNominalWeightByScript = (state, script) => {
  const crop = get(script.meta, 'crop', null);
  return crop && getNominalWeightByCropId(state, crop);
};
export const getUnitForCrop = (cropCode) => cropCode === 'soybeans' ? 'soybean' : cropCode;
export const getBushelAcreCropForCrop = (cropCode) => cropCode === 'soybeans' ? 'wheat_soybean' : cropCode;
